import TextStyleToolbarView from "./TextStyleToolbarView.vue";
import {TextStyle as TextStyleExtension} from "@tiptap/extension-text-style";
import {Color as ColorExtension} from "@tiptap/extension-color";

export default class TextStyle {

    constructor() {
        this.toolbarView = TextStyleToolbarView;
    }

    static create() {
        return new TextStyle();
    }

    getExtensions() {
        return [TextStyleExtension, ColorExtension];
    }
}